import React, { CSSProperties, ReactNode } from 'react'
import { Alert } from 'react-bootstrap'
import { AiOutlineInfoCircle, AiOutlineWarning } from 'react-icons/ai'
import { MdDone, MdErrorOutline } from 'react-icons/md'

import IconComponent from 'app_components/commons/icons'
import './../alert.scss'

interface IAlertLayoutProps {
  type?: 'info' | 'error' | 'success' | 'warning' | ''
  title?: string
  description?: string | ReactNode
  icon?: string
  sizeIcon?: string
  textAlign?: string
  textButton?: string
  showButton?: boolean
  onClick?: () => void
  styles?: any
  className?: string
}

const AlertLayout: React.FC<IAlertLayoutProps> = (props) => {

  const {
    type,
    title,
    description,
    icon,
    textButton,
    onClick,
    showButton,
    textAlign,
    sizeIcon,
  } = props

  const getBackgroundColor = () => {
    switch (type) {
      case 'info':
        return 'primary'
      case 'error':
        return 'danger'
      case 'success':
        return 'success'
      case 'warning':
        return 'warning'
      default:
        return ''
    }
  }

  const getIconFromType = () => {
    switch (type) {
      case 'info':
        return (<AiOutlineInfoCircle />)
      case 'error':
        return (<MdErrorOutline />)
      case 'success':
        return (<MdDone />)
      case 'warning':
        return (<AiOutlineWarning />)
      default:
        return (<AiOutlineInfoCircle />)
    }
  }

  const getDescription = () => {
    if (description !== undefined) return description
    return 'No hay datos disponibles'
  }

  const getTextAlign = () => {
    if (textAlign !== undefined) {
      const ta = textAlign
      return {textAlign: ta}
    } else {
      return {textAlign: 'left'}
    }
  }

  return (
    <div className={`alert-component ${props?.className ?? ''}`} style={(props.styles) ? props.styles : null}>
      <Alert
        className='alert-lms'
        variant={getBackgroundColor()}
      >
        <div className='container-alert'>
          <div className='column-icon'>
            <div>
              {icon === undefined
                ? getIconFromType()
                : <IconComponent
                  color={'rgba(0,0,0,0.5)'}
                  class_name='icon-svg'
                  svg={icon}
                  width={sizeIcon ? sizeIcon : undefined} height={sizeIcon ? sizeIcon : undefined}
                />
              }
            </div>
          </div>
            <div className='column-text' style={getTextAlign() as CSSProperties} >
              {title !== undefined
                ? <strong className='title-alert font-title'>{title}</strong>
                : <span className='desc-title font-text'>{getDescription()}</span>
              }
              {title === undefined ? null : description === undefined ? null :
                <>
                  <br />
                  <span className='font-text'>{description}</span>
                </>
              }
            </div>
            <div className='column-button'>
              {showButton
                ? <button onClick={onClick} >{textButton ? textButton : 'OK'}</button>
                : null
              }
            </div>
        </div>
      </Alert>
    </div>
  )
}

export default AlertLayout
